var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.49 1.25C2.49 1.9405 1.935 2.5 1.25 2.5C0.565 2.5 0.01 1.9405 0.01 1.25C0.01 0.56 0.565 0 1.25 0C1.935 0 2.49 0.56 2.49 1.25ZM2.5 3.5H0V11.5H2.5V3.5ZM6.491 3.5H4.007V11.5H6.4915V7.3005C6.4915 4.9655 9.506 4.7745 9.506 7.3005V11.5H12V6.4345C12 2.4945 7.539 2.638 6.491 4.5775V3.5Z","fill":"#1A1D31"}));
}

Linkedin.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
